/**
 * Validates a post-login `?redirect=` target.
 *
 * Only same-origin paths inside the dashboard are honoured. Anything else —
 * an absolute URL, a protocol-relative `//evil.com`, a backslash trick that
 * some browsers normalise into one, or a path outside `/dashboard` — returns
 * null and the caller falls back to its normal destination. An open redirect
 * on the login page is a phishing kit, so this errs hard on the side of null.
 */
export function safeDashboardRedirect(
  raw: string | null | undefined,
): string | null {
  if (!raw) return null;
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\")) {
    return null;
  }

  let url: URL;
  try {
    // Resolved against a throwaway origin: if the result lands anywhere else,
    // the input was not a plain path.
    url = new URL(raw, "https://fixrli.invalid");
  } catch {
    return null;
  }

  if (url.origin !== "https://fixrli.invalid") return null;
  if (url.pathname !== "/dashboard" && !url.pathname.startsWith("/dashboard/")) {
    return null;
  }

  return `${url.pathname}${url.search}`;
}

export const REDIRECT_PARAM = "redirect";
